// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyPage_root__20jA3"};